<div
  class="mobile-only"
  *ngIf="storageService.detectMob()"
  [ngClass]="{
    'dark-theme': analyticsService?.currentTheme === 'material-dark'
  }"
>
  <div>
    <div
      class="alert-container d-flex flex-column align-items-center text-center p-3 mb-3"
    >
      <img
        src="../../../assets/images/best-view-icon.svg"
        alt="Best View Icon"
        height="113px"
        width="145px"
        draggable="false"
      />

      <p class="alert-heading quicksand-semi-bold-label">
        Best Viewed on Larger Screens
      </p>
      <p class="sub-heading quicksand-bold-label">
        Editing the {{pageName}} works best on a tablet<br />
        or desktop. Try switching for a smoother<br />
        experience!
      </p>
    </div>
  </div>
</div>
